// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Avatar,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Menu,
//   MenuItem,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Checkbox,
//   Collapse,
//   Divider,
//   Alert,
// } from "@mui/material";
// import {
//   MoreVert as MoreVertIcon,
//   ExpandLess as ExpandLessIcon,
//   ExpandMore as ExpandMoreIcon,
//   Edit as EditIcon,
//   Person as PersonIcon,
//   Security as SecurityIcon,
//   History as HistoryIcon,
//   CheckCircle as CheckCircleIcon,
// } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { getUserDetails, getUserPermissionsByUserId } from "../../utils/api";
// import EditUserPermissionsModal from "../../components/EditUserPermissionsModal";
// import RecordProfilePage from "../../components/RecordProfilePage";
// import { getStatusChipStyle, BASE_CHIP_SX } from "../../constants/statusColors";
// import { ADMIN_ROUTES } from "../../constants/routes";

// const maroon = "#500000";

// const UserProfile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [tabValue, setTabValue] = useState(0);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [expandedSections, setExpandedSections] = useState({
//     admin: true,
//     biobank: true,
//     researcher: false,
//   });
//   const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);
//   const [userPermissions, setUserPermissions] = useState([]);
//   const [permissionsLoading, setPermissionsLoading] = useState(false);

//   // Get user ID from location state or URL params
//   const userId = location.state?.userId || location.pathname.split("/").pop();

//   const loadUserData = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const userData = await getUserDetails(userId);
//       console.log("User data loaded:", userData);
//       console.log("Department data (singular):", userData.department);
//       console.log("Departments data (plural):", userData.departments);
//       console.log("Job Role data (singular):", userData.jobRole);
//       console.log("Job Roles data (plural):", userData.jobRoles);
//       console.log("User Role data:", userData.userRole);
//       console.log("User Roles data (array):", userData.userRoles);
//       console.log("User Roles type:", typeof userData.userRoles);
//       console.log("User Roles isArray:", Array.isArray(userData.userRoles));
//       console.log("User Roles length:", userData.userRoles?.length);
//       setUser(userData);
//     } catch (err) {
//       console.error("Error loading user data:", err);
//       setError("Failed to load user data");
//     } finally {
//       setLoading(false);
//     }
//   }, [userId]);

//   const loadUserPermissions = useCallback(async () => {
//     if (!userId) return;

//     try {
//       setPermissionsLoading(true);
//       console.log("Loading permissions for userId:", userId);
//       const permissions = await getUserPermissionsByUserId(userId);
//       console.log("Permissions loaded for user:", permissions);
//       setUserPermissions(permissions);
//     } catch (err) {
//       console.error("Error loading user permissions:", err);
//       setUserPermissions([]);
//     } finally {
//       setPermissionsLoading(false);
//     }
//   }, [userId]);

//   useEffect(() => {
//     if (userId) {
//       loadUserData();
//       loadUserPermissions();
//     } else {
//       setError("No user ID provided");
//       setLoading(false);
//     }
//   }, [userId, loadUserData, loadUserPermissions]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   // Convert API permissions to UI format
//   const getPermissionsDataForUI = () => {
//     if (!userPermissions || userPermissions.length === 0) {
//       return {
//         admin: [],
//         biobank: [],
//         researcher: [],
//       };
//     }

//     const formattedPermissions = {
//       admin: [],
//       biobank: [],
//       researcher: [],
//     };

//     userPermissions.forEach((perm) => {
//       if (perm.module && perm.permission) {
//         const moduleLower = perm.module.toLowerCase();

//         if (moduleLower.includes("admin")) {
//           formattedPermissions.admin.push(perm.permission);
//         } else if (moduleLower.includes("biobank")) {
//           formattedPermissions.biobank.push(perm.permission);
//         } else if (moduleLower.includes("researcher")) {
//           formattedPermissions.researcher.push(perm.permission);
//         }
//       }
//     });

//     // Remove duplicates
//     Object.keys(formattedPermissions).forEach((key) => {
//       formattedPermissions[key] = [...new Set(formattedPermissions[key])];
//     });

//     return formattedPermissions;
//   };

//   const handleEditAccount = () => {
//     handleMenuClose();
//     navigate(ADMIN_ROUTES.USER_EDIT_REASON, {
//       state: {
//         user: user,
//         returnTo: ADMIN_ROUTES.USER_PROFILE(userId),
//       },
//     });
//   };

//   const handleDeactivateUser = () => {
//     handleMenuClose();
//     // TODO: Implement deactivate user functionality
//     console.log("Deactivate user:", userId);
//   };

//   const handleBackToTable = () => {
//     navigate(ADMIN_ROUTES.USER_MANAGEMENT);
//   };

//   const handleEditPermissions = () => {
//     setPermissionsModalOpen(true);
//   };

//   const handlePermissionsSave = async (permissionsData) => {
//     try {
//       console.log("Saving permissions:", permissionsData);

//       // Show success message
//       setSuccessMessage("User permissions updated successfully!");

//       // Close the modal
//       setPermissionsModalOpen(false);

//       // Reload user data and permissions to reflect the changes
//       await loadUserData();
//       await loadUserPermissions();

//       // Clear success message after 3 seconds
//       setTimeout(() => {
//         setSuccessMessage(null);
//       }, 3000);
//     } catch (err) {
//       console.error("Error saving permissions:", err);
//       setError("Failed to save permissions");
//     }
//   };

//   const handlePermissionsClose = () => {
//     setPermissionsModalOpen(false);
//   };

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   const getInitials = (firstName, lastName) => {
//     return `${firstName?.charAt(0) || ""}${
//       lastName?.charAt(0) || ""
//     }`.toUpperCase();
//   };


//   // Mock activity data - replace with real API call
//   const activityData = [
//     { activity: "Log In", date: "04/10/2025", time: "9:00 AM" },
//     { activity: "Activity Name", date: "04/10/2025", time: "9:00 AM" },
//     { activity: "Log In", date: "04/10/2025", time: "9:12 AM" },
//     { activity: "Log In", date: "04/09/2025", time: "8:45 AM" },
//     { activity: "Log In", date: "04/08/2025", time: "9:30 AM" },
//   ];

//   // Get permissions data from API
//   const permissionsData = getPermissionsDataForUI();

//   if (loading) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//         <Typography>Loading user data...</Typography>
//       </Box>
//     );
//   }

//   if (error || !user) {
//     return (
//       <Box sx={{ textAlign: "center", py: 4 }}>
//         <Typography color="error" variant="h6">
//           {error || "User not found"}
//         </Typography>
//         <Button
//           onClick={handleBackToTable}
//           variant="contained"
//           sx={{ mt: 2, backgroundColor: maroon }}
//         >
//           Back to User Management
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <RecordProfilePage title="User Profile" backTo={ADMIN_ROUTES.USER_MANAGEMENT} maxWidth={1200}>
//       {/* Success Message */}
//       {successMessage && (
//         <Alert
//           severity="success"
//           onClose={() => setSuccessMessage(null)}
//           sx={{ mb: 3 }}
//         >
//           {successMessage}
//         </Alert>
//       )}

//       {/* User Summary Card */}
//       <Paper
//         sx={{
//           p: 4,
//           mb: 3,
//           borderRadius: 2,
//           boxShadow: "none",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//           <Avatar
//             sx={{
//               width: 80,
//               height: 80,
//               backgroundColor: maroon,
//               fontSize: "2rem",
//               fontWeight: "bold",
//             }}
//           >
//             {getInitials(user.firstName, user.lastName)}
//           </Avatar>

//           <Box sx={{ flex: 1 }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   color: maroon,
//                   fontWeight: 700,
//                 }}
//               >
//                 {user.firstName} {user.lastName}
//               </Typography>
//               <Chip
//                 label={user.status || "Active"}
//                 size="small"
//                 sx={{
//                   ...BASE_CHIP_SX,
//                   ...getStatusChipStyle(user.status || "Active"),
//                 }}
//               />
//             </Box>

//             <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//               <Typography variant="body1" color="text.secondary">
//                 <strong>Active Since:</strong> April 2025
//               </Typography>
//               <Typography variant="body1" color="text.secondary">
//                 <strong>Email:</strong> {user.email}
//               </Typography>
//               <Typography variant="body1" color="text.secondary">
//                 <strong>Phone Number:</strong> 123-456-7890
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Pills Navigation */}
//       <Box sx={{ mb: 3, display: "flex", gap: 1 }}>
//         <Button
//           variant={tabValue === 0 ? "contained" : "outlined"}
//           onClick={() => handleTabChange(null, 0)}
//           startIcon={<PersonIcon />}
//           sx={{
//             textTransform: "none",
//             fontWeight: 600,
//             borderRadius: "24px",
//             px: 3,
//             py: 1.5,
//             minHeight: 48,
//             "&.MuiButton-contained": {
//               backgroundColor: maroon,
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "#4a0000",
//               },
//             },
//             "&.MuiButton-outlined": {
//               borderColor: maroon,
//               color: maroon,
//               backgroundColor: "white",
//               "&:hover": {
//                 borderColor: maroon,
//                 backgroundColor: "rgba(80, 0, 0, 0.1)",
//               },
//             },
//           }}
//         >
//           Account Information
//         </Button>

//         <Button
//           variant={tabValue === 1 ? "contained" : "outlined"}
//           onClick={() => handleTabChange(null, 1)}
//           startIcon={<SecurityIcon />}
//           sx={{
//             textTransform: "none",
//             fontWeight: 600,
//             borderRadius: "24px",
//             px: 3,
//             py: 1.5,
//             minHeight: 48,
//             "&.MuiButton-contained": {
//               backgroundColor: maroon,
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "#4a0000",
//               },
//             },
//             "&.MuiButton-outlined": {
//               borderColor: maroon,
//               color: maroon,
//               backgroundColor: "white",
//               "&:hover": {
//                 borderColor: maroon,
//                 backgroundColor: "rgba(80, 0, 0, 0.1)",
//               },
//             },
//           }}
//         >
//           User Permissions
//         </Button>

//         <Button
//           variant={tabValue === 2 ? "contained" : "outlined"}
//           onClick={() => handleTabChange(null, 2)}
//           startIcon={<HistoryIcon />}
//           sx={{
//             textTransform: "none",
//             fontWeight: 600,
//             borderRadius: "24px",
//             px: 3,
//             py: 1.5,
//             minHeight: 48,
//             "&.MuiButton-contained": {
//               backgroundColor: maroon,
//               color: "white",
//               "&:hover": {
//                 backgroundColor: "#4a0000",
//               },
//             },
//             "&.MuiButton-outlined": {
//               borderColor: maroon,
//               color: maroon,
//               backgroundColor: "white",
//               "&:hover": {
//                 borderColor: maroon,
//                 backgroundColor: "rgba(80, 0, 0, 0.1)",
//               },
//             },
//           }}
//         >
//           User Activity
//         </Button>
//       </Box>

//       {/* Tab Content */}
//       <Paper
//         elevation={0}
//         sx={{
//           borderRadius: "16px",
//           mb: 4,
//           p: 3,
//           minHeight: 400,
//         }}
//       >
//         {tabValue === 0 && (
//           <Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 3,
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
//                 Account Information
//               </Typography>
//               <IconButton onClick={handleMenuOpen}>
//                 <MoreVertIcon />
//               </IconButton>
//               <Menu
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={handleMenuClose}
//               >
//                 <MenuItem onClick={handleEditAccount}>
//                   <EditIcon sx={{ mr: 1 }} />
//                   Edit Account Information
//                 </MenuItem>
//                 <MenuItem onClick={handleDeactivateUser}>
//                   <SecurityIcon sx={{ mr: 1 }} />
//                   Deactivate User Account
//                 </MenuItem>
//               </Menu>
//             </Box>

//             <Box
//               sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}
//             >
//               <Box>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mb: 0.5 }}
//                 >
//                   Departments
//                 </Typography>
//                 <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                   {Array.isArray(user.departments)
//                     ? user.departments.join(", ")
//                     : Array.isArray(user.department)
//                     ? user.department.join(", ")
//                     : user.departments || user.department || "Not specified"}
//                 </Typography>
//               </Box>

//               <Box>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mb: 0.5 }}
//                 >
//                   Job Title
//                 </Typography>
//                 <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                   {Array.isArray(user.jobRoles)
//                     ? user.jobRoles.join(", ")
//                     : Array.isArray(user.jobRole)
//                     ? user.jobRole.join(", ")
//                     : user.jobRoles || user.jobRole || "Not specified"}
//                 </Typography>
//               </Box>

//               <Box>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mb: 0.5 }}
//                 >
//                   User Roles
//                 </Typography>
//                 <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                   {(() => {
//                     console.log(
//                       "Rendering User Roles - user.userRoles:",
//                       user.userRoles
//                     );
//                     console.log(
//                       "Rendering User Roles - isArray:",
//                       Array.isArray(user.userRoles)
//                     );
//                     console.log(
//                       "Rendering User Roles - length:",
//                       user.userRoles?.length
//                     );
//                     return Array.isArray(user.userRoles) &&
//                       user.userRoles.length > 0
//                       ? user.userRoles.join(", ")
//                       : "Not specified";
//                   })()}
//                 </Typography>
//               </Box>

//               <Box>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mb: 0.5 }}
//                 >
//                   Purpose for Access
//                 </Typography>
//                 <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                   {Array.isArray(user.purposeForAccess)
//                     ? user.purposeForAccess.join(", ")
//                     : user.purposeForAccess || "Not specified"}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//         )}

//         {tabValue === 1 && (
//           <Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 3,
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
//                 User Permissions
//               </Typography>
//               <Button
//                 variant="outlined"
//                 startIcon={<EditIcon />}
//                 onClick={handleEditPermissions}
//                 sx={{
//                   borderColor: "#ccc",
//                   color: "#666",
//                   textTransform: "none",
//                   "&:hover": {
//                     borderColor: maroon,
//                     color: maroon,
//                     backgroundColor: "rgba(80, 0, 0, 0.1)",
//                   },
//                 }}
//               >
//                 Edit User Permissions
//               </Button>
//             </Box>

//             <List>
//               {Object.entries(permissionsData).map(([section, permissions]) => (
//                 <Box key={section}>
//                   <ListItem
//                     button
//                     onClick={() => toggleSection(section)}
//                     disabled={permissions.length === 0}
//                     sx={{
//                       backgroundColor: expandedSections[section]
//                         ? "rgba(80, 0, 0, 0.1)"
//                         : "transparent",
//                       borderRadius: 1,
//                       mb: 0.5,
//                       "&.Mui-disabled": {
//                         opacity: 0.5,
//                       },
//                     }}
//                   >
//                     <ListItemIcon>
//                       <Checkbox
//                         checked={permissions.length > 0}
//                         disabled={permissions.length === 0}
//                         sx={{ color: maroon }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={
//                         section.charAt(0).toUpperCase() + section.slice(1)
//                       }
//                       sx={{ textTransform: "capitalize", fontWeight: 600 }}
//                     />
//                     {expandedSections[section] ? (
//                       <ExpandLessIcon />
//                     ) : (
//                       <ExpandMoreIcon />
//                     )}
//                   </ListItem>

//                   <Collapse
//                     in={expandedSections[section]}
//                     timeout="auto"
//                     unmountOnExit
//                   >
//                     <List component="div" disablePadding>
//                       {permissions.length > 0 ? (
//                         permissions.map((permission) => (
//                           <ListItem key={permission} sx={{ pl: 6 }}>
//                             <ListItemIcon>
//                               <Checkbox
//                                 checked={true}
//                                 disabled
//                                 sx={{ color: maroon }}
//                               />
//                             </ListItemIcon>
//                             <ListItemText primary={permission} />
//                           </ListItem>
//                         ))
//                       ) : (
//                         <ListItem sx={{ pl: 6 }}>
//                           <ListItemText
//                             primary="No permissions assigned"
//                             sx={{
//                               color: "text.secondary",
//                               fontStyle: "italic",
//                             }}
//                           />
//                         </ListItem>
//                       )}
//                     </List>
//                   </Collapse>
//                 </Box>
//               ))}
//             </List>
//           </Box>
//         )}

//         {tabValue === 2 && (
//           <Box>
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: 600, color: maroon, mb: 3 }}
//             >
//               User Activity
//             </Typography>

//             <TableContainer>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell sx={{ fontWeight: 600, color: maroon }}>
//                       Activity
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, color: maroon }}>
//                       Date
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, color: maroon }}>
//                       Time
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {activityData.map((row, index) => (
//                     <TableRow key={index}>
//                       <TableCell>{row.activity}</TableCell>
//                       <TableCell>{row.date}</TableCell>
//                       <TableCell>{row.time}</TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mt: 2,
//               }}
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Rows per page: 10
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 1-10 of 25
//               </Typography>
//             </Box>
//           </Box>
//         )}
//       </Paper>

//       {/* Edit Permissions Modal */}
//       <EditUserPermissionsModal
//         open={permissionsModalOpen}
//         onClose={handlePermissionsClose}
//         onSave={handlePermissionsSave}
//         user={user}
//       />
//     </RecordProfilePage>
//   );
// };

// export default UserProfile;


import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Alert,
  Grid,
} from "@mui/material";
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Person as PersonIcon,
  Security as SecurityIcon,
  History as HistoryIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserDetails, getUserPermissionsByUserId, fetchActiveStudies } from "../../utils/api";
import EditUserPermissionsModal from "../../components/EditUserPermissionsModal";
import RecordProfilePage from "../../components/RecordProfilePage";
import { getStatusChipStyle, BASE_CHIP_SX } from "../../constants/statusColors";
import { ADMIN_ROUTES } from "../../constants/routes";

const maroon = "#500000";

const UserProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    admin: true,
    biobank: true,
    researcher: false,
  });
  const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(false);
  const [studies, setStudies] = useState([]);

  // Get user ID from location state or URL params
  const userId = location.state?.userId || location.pathname.split("/").pop();

  const loadUserData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const userData = await getUserDetails(userId);
      console.log("User data loaded:", userData);
      console.log("Department data (singular):", userData.department);
      console.log("Departments data (plural):", userData.departments);
      console.log("Job Role data (singular):", userData.jobRole);
      console.log("Job Roles data (plural):", userData.jobRoles);
      console.log("User Role data:", userData.userRole);
      console.log("User Roles data (array):", userData.userRoles);
      console.log("User Roles type:", typeof userData.userRoles);
      console.log("User Roles isArray:", Array.isArray(userData.userRoles));
      console.log("User Roles length:", userData.userRoles?.length);
      setUser(userData);
    } catch (err) {
      console.error("Error loading user data:", err);
      setError("Failed to load user data");
    } finally {
      setLoading(false);
    }
  }, [userId]);

  const loadUserPermissions = useCallback(async () => {
    if (!userId) return;

    try {
      setPermissionsLoading(true);
      console.log("Loading permissions for userId:", userId);
      const permissions = await getUserPermissionsByUserId(userId);
      console.log("Permissions loaded for user:", permissions);
      setUserPermissions(permissions);
    } catch (err) {
      console.error("Error loading user permissions:", err);
      setUserPermissions([]);
    } finally {
      setPermissionsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      loadUserData();
      loadUserPermissions();
    } else {
      setError("No user ID provided");
      setLoading(false);
    }
  }, [userId, loadUserData, loadUserPermissions]);

  useEffect(() => {
    const loadStudies = async () => {
      try {
        const activeStudies = await fetchActiveStudies();
        setStudies(activeStudies);
      } catch (err) {
        console.error("Error loading studies:", err);
        setStudies([]);
      }
    };
    loadStudies();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Convert API permissions to UI format
  const getPermissionsDataForUI = () => {
    if (!userPermissions || userPermissions.length === 0) {
      return {
        admin: [],
        biobank: [],
        researcher: [],
        studies: [],
      };
    }

    const formattedPermissions = {
      admin: [],
      biobank: [],
      researcher: [],
      studies: [],
    };

    userPermissions.forEach((perm) => {
      if (perm.module && perm.permission) {
        const moduleLower = perm.module.toLowerCase();

        if (moduleLower.includes("admin")) {
          formattedPermissions.admin.push(perm.permission);
        } else if (moduleLower.includes("biobank")) {
          formattedPermissions.biobank.push(perm.permission);
        } else if (moduleLower.includes("researcher")) {
          formattedPermissions.researcher.push(perm.permission);
        } else if (moduleLower === "study") {
          const matchedStudy = studies.find(
            (study) => study.irbStudy === perm.permission
          );
          formattedPermissions.studies.push(
            matchedStudy ? matchedStudy.name : perm.permission
          );
        }
      }
    });

    // Remove duplicates
    Object.keys(formattedPermissions).forEach((key) => {
      formattedPermissions[key] = [...new Set(formattedPermissions[key])];
    });

    return formattedPermissions;
  };

  const handleEditAccount = () => {
    handleMenuClose();
    navigate(ADMIN_ROUTES.USER_EDIT_REASON, {
      state: {
        user: user,
        returnTo: ADMIN_ROUTES.USER_PROFILE(userId),
      },
    });
  };

  const handleDeactivateUser = () => {
    handleMenuClose();
    // TODO: Implement deactivate user functionality
    console.log("Deactivate user:", userId);
  };

  const handleBackToTable = () => {
    navigate(ADMIN_ROUTES.USER_MANAGEMENT);
  };

  const handleEditPermissions = () => {
    setPermissionsModalOpen(true);
  };

  const handlePermissionsSave = async (permissionsData) => {
    try {
      console.log("Saving permissions:", permissionsData);

      // Show success message
      setSuccessMessage("User permissions updated successfully!");

      // Close the modal
      setPermissionsModalOpen(false);

      // Reload user data and permissions to reflect the changes
      await loadUserData();
      await loadUserPermissions();

      // Clear success message after 3 seconds
      setTimeout(() => {
        setSuccessMessage(null);
      }, 3000);
    } catch (err) {
      console.error("Error saving permissions:", err);
      setError("Failed to save permissions");
    }
  };

  const handlePermissionsClose = () => {
    setPermissionsModalOpen(false);
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ""}${
      lastName?.charAt(0) || ""
    }`.toUpperCase();
  };


  // Mock activity data - replace with real API call
  const activityData = [
    { activity: "Log In", date: "04/10/2025", time: "9:00 AM" },
    { activity: "Activity Name", date: "04/10/2025", time: "9:00 AM" },
    { activity: "Log In", date: "04/10/2025", time: "9:12 AM" },
    { activity: "Log In", date: "04/09/2025", time: "8:45 AM" },
    { activity: "Log In", date: "04/08/2025", time: "9:30 AM" },
  ];

  // Get permissions data from API
  const permissionsData = getPermissionsDataForUI();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <Typography>Loading user data...</Typography>
      </Box>
    );
  }

  if (error || !user) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography color="error" variant="h6">
          {error || "User not found"}
        </Typography>
        <Button
          onClick={handleBackToTable}
          variant="contained"
          sx={{ mt: 2, backgroundColor: maroon }}
        >
          Back to User Management
        </Button>
      </Box>
    );
  }

  return (
    <RecordProfilePage title="User Profile" backTo={ADMIN_ROUTES.USER_MANAGEMENT} maxWidth={1200}>
      {/* Success Message */}
      {successMessage && (
        <Alert
          severity="success"
          onClose={() => setSuccessMessage(null)}
          sx={{ mb: 3 }}
        >
          {successMessage}
        </Alert>
      )}

      {/* User Summary Card */}
      <Paper
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          boxShadow: "none",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              backgroundColor: maroon,
              fontSize: "2rem",
              fontWeight: "bold",
            }}
          >
            {getInitials(user.firstName, user.lastName)}
          </Avatar>

          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
              <Typography
                variant="h4"
                sx={{
                  color: maroon,
                  fontWeight: 700,
                }}
              >
                {user.firstName} {user.lastName}
              </Typography>
              <Chip
                label={user.status || "Active"}
                size="small"
                sx={{
                  ...BASE_CHIP_SX,
                  ...getStatusChipStyle(user.status || "Active"),
                }}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              <Typography variant="body1" color="text.secondary">
                <strong>Active Since:</strong> April 2025
              </Typography>
              <Typography variant="body1" color="text.secondary">
                <strong>Email:</strong> {user.email}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                <strong>Phone Number:</strong> 123-456-7890
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Pills Navigation */}
      <Box sx={{ mb: 3, display: "flex", gap: 1 }}>
        <Button
          variant={tabValue === 0 ? "contained" : "outlined"}
          onClick={() => handleTabChange(null, 0)}
          startIcon={<PersonIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "24px",
            px: 3,
            py: 1.5,
            minHeight: 48,
            "&.MuiButton-contained": {
              backgroundColor: maroon,
              color: "white",
              "&:hover": {
                backgroundColor: "#4a0000",
              },
            },
            "&.MuiButton-outlined": {
              borderColor: maroon,
              color: maroon,
              backgroundColor: "white",
              "&:hover": {
                borderColor: maroon,
                backgroundColor: "rgba(80, 0, 0, 0.1)",
              },
            },
          }}
        >
          Account Information
        </Button>

        <Button
          variant={tabValue === 1 ? "contained" : "outlined"}
          onClick={() => handleTabChange(null, 1)}
          startIcon={<SecurityIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "24px",
            px: 3,
            py: 1.5,
            minHeight: 48,
            "&.MuiButton-contained": {
              backgroundColor: maroon,
              color: "white",
              "&:hover": {
                backgroundColor: "#4a0000",
              },
            },
            "&.MuiButton-outlined": {
              borderColor: maroon,
              color: maroon,
              backgroundColor: "white",
              "&:hover": {
                borderColor: maroon,
                backgroundColor: "rgba(80, 0, 0, 0.1)",
              },
            },
          }}
        >
          Permissions
        </Button>

        <Button
          variant={tabValue === 2 ? "contained" : "outlined"}
          onClick={() => handleTabChange(null, 2)}
          startIcon={<HistoryIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "24px",
            px: 3,
            py: 1.5,
            minHeight: 48,
            "&.MuiButton-contained": {
              backgroundColor: maroon,
              color: "white",
              "&:hover": {
                backgroundColor: "#4a0000",
              },
            },
            "&.MuiButton-outlined": {
              borderColor: maroon,
              color: maroon,
              backgroundColor: "white",
              "&:hover": {
                borderColor: maroon,
                backgroundColor: "rgba(80, 0, 0, 0.1)",
              },
            },
          }}
        >
          User Activity
        </Button>
      </Box>

      {/* Tab Content */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "16px",
          mb: 4,
          p: 3,
          minHeight: 400,
        }}
      >
        {tabValue === 0 && (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
                Account Information
              </Typography>
              <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleEditAccount}>
                  <EditIcon sx={{ mr: 1 }} />
                  Edit Account Information
                </MenuItem>
                <MenuItem onClick={handleDeactivateUser}>
                  <SecurityIcon sx={{ mr: 1 }} />
                  Deactivate User Account
                </MenuItem>
              </Menu>
            </Box>

            <Box
              sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}
            >
              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  Departments
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {Array.isArray(user.departments)
                    ? user.departments.join(", ")
                    : Array.isArray(user.department)
                    ? user.department.join(", ")
                    : user.departments || user.department || "Not specified"}
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  Job Title
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {Array.isArray(user.jobRoles)
                    ? user.jobRoles.join(", ")
                    : Array.isArray(user.jobRole)
                    ? user.jobRole.join(", ")
                    : user.jobRoles || user.jobRole || "Not specified"}
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  User Roles
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {(() => {
                    console.log(
                      "Rendering User Roles - user.userRoles:",
                      user.userRoles
                    );
                    console.log(
                      "Rendering User Roles - isArray:",
                      Array.isArray(user.userRoles)
                    );
                    console.log(
                      "Rendering User Roles - length:",
                      user.userRoles?.length
                    );
                    return Array.isArray(user.userRoles) &&
                      user.userRoles.length > 0
                      ? user.userRoles.join(", ")
                      : "Not specified";
                  })()}
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                >
                  Purpose for Access
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {Array.isArray(user.purposeForAccess)
                    ? user.purposeForAccess.join(", ")
                    : user.purposeForAccess || "Not specified"}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {tabValue === 1 && (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2.5,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, color: maroon }}>
                Permissions
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<EditIcon fontSize="small" />}
                onClick={handleEditPermissions}
                sx={{
                  borderColor: "#ccc",
                  color: "#666",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: maroon,
                    color: maroon,
                    backgroundColor: "rgba(80, 0, 0, 0.06)",
                  },
                }}
              >
                Edit Module &amp; Study Permissions
              </Button>
            </Box>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 2.5 }}
            >
              What this user can access, and in which studies.
            </Typography>

            <Paper
              variant="outlined"
              sx={{
                borderRadius: 2,
                borderColor: "#e0e0e0",
                overflow: "hidden",
              }}
            >
              <Grid container>
                {/* Study Access */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    p: 3,
                    borderRight: { md: "1px solid #eee" },
                    borderBottom: { xs: "1px solid #eee", md: "none" },
                  }}
                >
                  <Typography
                    variant="overline"
                    sx={{
                      color: maroon,
                      fontWeight: 700,
                      letterSpacing: 0.6,
                    }}
                  >
                    Study Access
                  </Typography>
                  <Divider sx={{ mt: 0.5, mb: 1.5 }} />

                  {permissionsData.studies.length > 0 ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      {permissionsData.studies.map((study) => (
                        <Box
                          key={study}
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <CheckCircleIcon
                            sx={{ color: maroon, fontSize: 16 }}
                          />
                          <Typography variant="body2">{study}</Typography>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ color: "text.disabled", fontStyle: "italic" }}
                    >
                      No studies assigned
                    </Typography>
                  )}
                </Grid>

                {/* Module Access */}
                <Grid item xs={12} md={6} sx={{ p: 3 }}>
                  <Typography
                    variant="overline"
                    sx={{
                      color: maroon,
                      fontWeight: 700,
                      letterSpacing: 0.6,
                    }}
                  >
                    Module Access
                  </Typography>
                  <Divider sx={{ mt: 0.5, mb: 1.5 }} />

                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
                    {["admin", "biobank", "researcher"].map((section) => {
                      const permissions = permissionsData[section];
                      const label =
                        section === "biobank"
                          ? "BioBank"
                          : section.charAt(0).toUpperCase() + section.slice(1);
                      return (
                        <Box key={section}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: permissions.length > 0 ? "text.primary" : "text.disabled",
                            }}
                          >
                            {label}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: permissions.length > 0 ? "text.secondary" : "text.disabled",
                              fontStyle: permissions.length > 0 ? "normal" : "italic",
                            }}
                          >
                            {permissions.length > 0
                              ? permissions.join(", ")
                              : "Not granted"}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )}

        {tabValue === 2 && (
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: maroon, mb: 3 }}
            >
              User Activity
            </Typography>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: maroon }}>
                      Activity
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: maroon }}>
                      Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, color: maroon }}>
                      Time
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activityData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.activity}</TableCell>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.time}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Rows per page: 10
              </Typography>
              <Typography variant="body2" color="text.secondary">
                1-10 of 25
              </Typography>
            </Box>
          </Box>
        )}
      </Paper>

      {/* Edit Permissions Modal */}
      <EditUserPermissionsModal
        open={permissionsModalOpen}
        onClose={handlePermissionsClose}
        onSave={handlePermissionsSave}
        user={user}
      />
    </RecordProfilePage>
  );
};

export default UserProfile;